import React, { forwardRef } from 'react';

import { LexicalEditor } from './LexicalEditor';

/**
 * Props for RichTextInput. Intentionally free of any editor-library types
 * so the underlying implementation (currently Lexical) can be swapped out
 * without changing the public API.
 */
export interface RichTextInputProps {
  /** Initial markdown content (uncontrolled) */
  defaultValue?: string;
  /** Fired with a markdown string on every content change */
  onChange?: (markdown: string) => void;
  /** Fired with a markdown string when the user submits (Enter without Shift) */
  onSubmit?: (markdown: string) => void;
  placeholder?: string;
  disabled?: boolean;
  /**
   * Applied to the editor container. Use this to control sizing, padding,
   * background, border, etc.
   * e.g. "min-h-[44px] px-3 py-2.5 rounded-lg border bg-background"
   */
  className?: string;
  autoFocus?: boolean;
}

/** Imperative handle for programmatic control of the input */
export interface RichTextInputHandle {
  /** Clears all content and resets the editor */
  clear: () => void;
  /** Focuses the editor */
  focus: () => void;
}

export const RichTextInput = forwardRef<RichTextInputHandle, RichTextInputProps>((props, ref) => (
  <LexicalEditor {...props} forwardedRef={ref} />
));
RichTextInput.displayName = 'RichTextInput';
